/**
 * VFX Runtime Module
 * 
 * Platform-agnostic VFX emitter management system.
 * Works with any render context that supports compute shaders.
 */

export { VFXEmitterManager } from './VFXEmitterManager';
export {
  registerVFXShader,
  registerVFXShaders,
  hasVFXShader,
  getVFXShader,
  getVFXShaderOrNull,
  getAllVFXShaders,
  clearVFXShaders,
  vfxShaderId,
  vfxShaderPath,
  VFX_SHADER_CACHE_DIR,
} from './VFXShaderCache';
export type { VFXShaderFormat } from './VFXShaderCache';
export type {
  EmitterSpawnMode,
  EmitterBurstConfig,
  EmitterState,
  EmitterOptions,
  GraphLoader,
  ShaderLoader,
  IVFXRenderer,
  EmitterManagerOptions,
  EmitterManagerStats,
  TextureResolver,
  PointmapResolver,
  CompiledDataLoader,
  CompiledDataResult,
  CompiledSystemInfo,
  LightEmittingSystemInfo,
} from './types';
